import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized-layout',
    imports: [],
    templateUrl: './unauthorized-layout.component.html',
    styleUrl: './unauthorized-layout.component.scss'
})
export class UnauthorizedLayoutComponent {

}
